import React from "react";
import "./Header.css";
import { AppBar, Box, Toolbar, Typography, Container } from "@mui/material";
import LogoHeader from "../../Components/LogoHeader/LogoHeader";
import MenuUser from "../../Components/MenuUser/MenuUser";
import MenuFlows from "../../Components/MenuFlows/MenuFlows";
import MenuTeams from "../../Components/MenuTeams/MenuTeams";
import HelpButton from "../../Components/HelpButton/HelpButton";
import NotificationButton from "../../Components/NotificationButton/NotificationButton";
import logo from '../../logo.png';
import LogoutIcon from '@mui/icons-material/Logout';

/**
 * The header component for the application. It includes the logo, navigation menus, and utility buttons
 * such as notifications and help. The header is styled using Material-UI and is designed to be responsive.
 * 
 * @component
 * @example
 * <Header />
 * @returns {React.Component} The rendered header component.
 */
function Header() {
  /**
   * Styles for the AppBar component in the header.
   */
  const AppBarStyle = {
    backgroundColor: "white",    
    maxWidth: "99%",
    borderRadius: "18px",
    margin: "8px"
  };
  /**
   * The list of menu items for the user menu, including a logout option.
   */
  const menuList = [
  {
    label: "Logout",
    action: "sign_out",
    value: "sign_out",
    icon: <LogoutIcon sx={{fontSize: "18px", marginRight: "4px"}}/>
  }]

  return (
    <Box className="appHeader">
      <AppBar color="default" sx={AppBarStyle}>
        <Container className="appHeaderContainer">
          <Toolbar className="appHeaderToolbar">
            <LogoHeader img={logo} alt={"ALBA"}/>
            <Typography component="div" sx={{ flexGrow: 1 }}/>
            <MenuFlows menuList={[]}/>
            <MenuTeams menuList={[]}/>
            <NotificationButton/>
            <HelpButton/>
            <MenuUser menuList={menuList}/>
          </Toolbar>
        </Container>
      </AppBar>
    </Box>
  );
}

export default Header;
